import React, { useState } from 'react';
import { MessageClass, TextPart } from '@cotera/sdk/core';
import { ChevronDown, ChevronRight, Sparkles } from 'lucide-react';
import { cn } from '../lib/utils';

interface CompactionMessageProps {
  message: MessageClass;
}

export const CompactionMessage: React.FC<CompactionMessageProps> = ({
  message,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Extract the summary text from the message parts (hydrated)
  const summaryText = message.parts
    .filter((part): part is TextPart => part.isTextPart())
    .map((part) => part.text)
    .join('\n')
    .replace('[Conversation Summary]\n\n', ''); // Remove the prefix

  return (
    <div className="my-4 mx-auto max-w-3xl">
      <div
        className={cn(
          'rounded-lg border border-border bg-muted/30 transition-all',
          isExpanded && 'bg-muted/50'
        )}
      >
        {/* Header - always visible */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full px-4 py-3 flex items-center gap-3 hover:bg-muted/40 transition-colors rounded-lg"
        >
          <div className="flex items-center gap-2 flex-1">
            <Sparkles className="h-4 w-4 text-primary" />
            <span className="text-sm font-medium text-foreground">
              Conversation Context Summarised
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>{isExpanded ? 'Hide' : 'Show'} summary</span>
            {isExpanded ? (
              <ChevronDown className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </div>
        </button>

        {/* Expandable content */}
        {isExpanded && (
          <div className="px-4 pb-3 pt-3 border-t border-border/50">
            <div className="text-sm text-muted-foreground whitespace-pre-wrap">
              {summaryText}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
